export const AUTH_LOADING = 'AUTH_LOADING'
export const SIGNED_IN = 'SIGNED_IN'
export const AUTH_ERROR = 'AUTH_ERROR'
export const SET_USER = 'SET_USER'
export const SET_FORGOT_PASSWORD = 'SET_FORGOT_PASSWORD'
